import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuthData } from "../../../services/storage/LocalStorage";
import { fullBotScriptReset, sendParamsToSpinnet, removeBotScript, removeChatInWindowScript, removeBotStyles, spinnetMicroAppsScriptSrc, loadSpinnetMicroAppsScriptStyles } from "../../../utils/ChatbotScriptHelpers";
import { SOCKET } from "../../../services/socket/initWebSocket";
import { useNavigate } from "react-router-dom";
import { useOnlineStatus } from "../../../services/customHooks/useOnlineStatus";
import { setBotWaitLoader, setBotWaitLoaderWithShimmer } from "../../../state/actions/loader";


const SpinnetMicroApps = ({
  isLoading,
  baseUrl,
  botId,
  email,
  mobileSession,
  appType,
  platform = "web",
  conversationId,
  userDomain = "onship",
  version = "1.0.0",
  botSubscriptions,
  refreshToken,
  connectionId
}) => {

  baseUrl = baseUrl?.includes('https') ? baseUrl : `https://${baseUrl}`
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authData = getAuthData();
  const selectedDomain = useSelector((state) => state.domain?.selectedDomain);
  const clearCacheForSpinnetBot = useSelector((state) => state.bot?.clearCacheForSpinnetBot);
  const [initialClearCache] = useState(clearCacheForSpinnetBot);
  // const [restartKey, setRestartKey] = useState(0);
  const isUserOnline = useOnlineStatus();

  let bots = botSubscriptions;

  const styleId = "spinnetmicroapps-as-widget-styles";
  const stylePath = "/scripts/spinnetMicroApps/static/css/main.bfae4cbd.css";

  useEffect(() => {
    if(isUserOnline) {
      performCleanupAndLoad();
      removeBotScript();
      removeChatInWindowScript()
      removeBotStyles();
    }else {
      console.log("user is offline", isUserOnline)
    }
  }, [selectedDomain, isUserOnline]);

  // useEffect(() => {
  //   if (isLoading) {
  //     setRestartKey(Date.now());
  //   }
  // }, [isLoading]);

  const performCleanupAndLoad = async () => {
    // Clear the spinnet root element for fresh load
    const spinnetRoot = document.getElementById("spinnet-microapps-root");
    if (spinnetRoot) {
      spinnetRoot.innerHTML = "";
    }

    // Destroy existing spinnet widget if available
    try {
      if (typeof window.destroyChatWidget === "function") {
        window.destroyChatWidget();
      }
    } catch (err) {
      console.warn("Error while calling destroyChatWidget:", err);
    }

    const response = await fullBotScriptReset();
    if (response === true) {
      setTimeout(() => {
        loadSpinnetMicroAppsScriptStyles(styleId, stylePath);
        loadSpinnetMicroAppsScript();
      }, 300);
    }
  };

  const loadSpinnetMicroAppsScript = () => {
    // Remove existing spinnet script if present
    const existingScript = document.querySelector(`script[src="${spinnetMicroAppsScriptSrc}"]`);
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }

    setTimeout(() => {
      const paramsSentRef = { current: false };
      const script = document.createElement('script');
      script.src = spinnetMicroAppsScriptSrc;
      script.async = true;
      const nativeEnv = process.env.REACT_APP_ENV || 'development';
      script.onload = () => {
        // console.log("Chatwidget Script loaded successfully.");
        const sendParamsWhenReady = () => {
          if (SOCKET?.isConnected && email && mobileSession && appType && conversationId && platform && botId && userDomain && connectionId && refreshToken && nativeEnv) {
            const params = {
              email: email,
              mobileSession: mobileSession,
              appType: appType,
              conversationId: conversationId,
              platform: platform,
              botId: botId,
              version: version,
              userDomain: userDomain,
              isHomepage: "false",
              clearCache: "false",
              connectionId: connectionId,
              refreshToken: refreshToken,
              ws: SOCKET.ws,
              nativeEnv
            };
            sendParamsToSpinnet(params);
            dispatch(setBotWaitLoaderWithShimmer(false));
            dispatch(setBotWaitLoader(false));
            // if (isDefaultHomePageBot && clearCacheForSpinnetBot) {
            //   dispatch(setClearCacheForSpinnetBot(false));
            // }
          } else {
            // console.warn(`Waiting for socket connection...`);
            setTimeout(() => sendParamsWhenReady(), 1000);
          }
        };

        setTimeout(() => sendParamsWhenReady(), 1000);
      };

      script.onerror = (e) => {
        console.error("Error loading the script: ", e);
        dispatch(setBotWaitLoaderWithShimmer(false));
        dispatch(setBotWaitLoader(false));
      };
      document.body.appendChild(script);
    }, 100);
  };

  return (
    <>
      <div>
        {/* {isLoading && (
          <FrontmGifLogoLoader className="!absolute !top-1/2 !left-1/2 !transform !-translate-x-1/2 !-translate-y-1/2 z-[999]" restartKey={restartKey} />
        )} */}
        {/* Chatbot Embed Container */}
        <div className="flex-1 bg-[#FFF]">
          <div id="spinnet-microapps-root"></div>
        </div>
      </div>
    </>
  );
};

export default SpinnetMicroApps;
